<template>
    <div>
        <design-2021-apprentice-display-html-component
            class="profile-text"
            :html-content="card.text">
        </design-2021-apprentice-display-html-component>

        <div
            class="image-group-wrapper"
            v-if="images.length">
            <design-2021-profile-card-image-component :images="images"></design-2021-profile-card-image-component>
        </div>

        <div
            class="video-file"
            v-if="videos.length"
            v-for="video of videos">
            <design-2021-apprentice-video-player-component :options="getVideoOptions(video)">
            </design-2021-apprentice-video-player-component>
        </div>

        <div
            class="video-link"
            v-for="videoLink of card.video_links">
            <design-2021-apprentice-video-link-player-component
                :options="playerOptions"
                :src="videoLink.url">
            </design-2021-apprentice-video-link-player-component>
        </div>

        <div
            class="regular-files"
            v-if="otherFiles.length">
            <design-2021-profile-card-file-component
                :card="card"
                :other-files="otherFiles"></design-2021-profile-card-file-component>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-profile-card-component',
    props: ['card'],
    data() {
        return {
            playerOptions: {
                responsive: true,
                autoplay: false,
                controls: true,
            },
        };
    },
    computed: {
        images() {
            if (!this.card.profile_card_files.length) {
                return [];
            }
            return this.card.profile_card_files.filter((f) => {
                const extensions = [
                    'jpg',
                    'JPG',
                    'jpeg',
                    'JPEG',
                    'png',
                    'PNG',
                    'gif',
                    'GIF',
                    'tiff',
                    'TIFF',
                    'bmp',
                    'BMP',
                    'jif',
                    'jfif',
                ];
                for (const ext of extensions) {
                    if (ext === f.file.extension) {
                        return true;
                    }
                }
                return false;
            });
        },
        videos() {
            if (!this.card.profile_card_files.length) {
                return [];
            }
            return this.card.profile_card_files.filter((f) => {
                const extensions = ['mp4', 'webm', 'ogv', 'ogg', 'mov', 'avi', 'm4v'];
                for (const ext of extensions) {
                    if (ext === f.file.extension) {
                        return true;
                    }
                }
                return false;
            });
        },
        otherFiles() {
            if (!this.card.profile_card_files.length) {
                return [];
            }
            return this.card.profile_card_files.filter((f) => {
                const extensions = [
                    'jpg',
                    'JPG',
                    'jpeg',
                    'JPEG',
                    'png',
                    'PNG',
                    'gif',
                    'GIF',
                    'tiff',
                    'TIFF',
                    'bmp',
                    'BMP',
                    'mp4',
                    'webm',
                    'ogv',
                    'ogg',
                    'mov',
                    'avi',
                    'm4v',
                    'jif',
                    'jfif',
                ];
                for (const ext of extensions) {
                    if (ext === f.file.extension) {
                        return false;
                    }
                }
                return true;
            });
        },
    },
    methods: {
        getVideoOptions(video) {
            let source = [];
            if (video.file) {
                source.push({
                    src: video.file ? video.file.public_path : '',
                    type: `video/${video.file.extension}`,
                });
            }

            return {
                autoplay: false,
                controls: true,
                sources: source,
            };
        },
    },
};
</script>

<style scoped lang="scss">
.image-group-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    &:not(:last-child) {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    }
}

.video-file:not(:last-child),
.image-group-wrapper:not(:last-child),
.video-link:not(:last-child),
.regular-files:not(:last-child) {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}
</style>
